import numeral from 'numeral';
import React from 'react'
import Swal from 'sweetalert2'
import { CancelarOrdenAsync } from '../Servicios/ServiciosPublicos';

export const OrdenRender = (params) => {

    const { Item } = params
    const OnClick = async (item) => {
        if (!params.OnClick) {
            let _result = await Swal.fire({
                title: ``,
                html: `¿Desea cancelar la orden: ${item.Tipo} por ${numeral(item.Precio).format("0,000.00")}?`,
                icon: 'question',
                confirmButtonText: 'Si',
                showCancelButton: true,
                cancelButtonText: "No"
            });
            if (_result.value) {
                let _orden = {
                    oid: item.id
                };
                let r = await CancelarOrdenAsync(_orden);
                await Swal.fire({
                    title: ``,
                    text: r.success ? "Se canceló la orden" : `${r.error.code} ${r.error.message}`,
                    icon: r.success ? 'success' : "error",
                    confirmButtonText: 'Aceptar',
                });
                if (r.success && params.ObtenerOrdenesActivas) { params.ObtenerOrdenesActivas(); }
            }
        } else { params.OnClick(item); }
    }

    const _moneda = Item.Item.book.replace("_mxn", "");

    return (<>
        <div className="tbl-cripto-item" onClick={() => { OnClick(Item); }}>
            <div className="row18">
                {
                    params.MostrarMoneda && (<div>Moneda</div>)
                }
                {
                    +params.PorVenta > 0 && (<div>% Venta</div>)
                }
                {
                    +params.PorCompra > 0 && (<div>% Compra</div>)
                }
                <div>Tipo</div>
                <div>Precio MXN</div>
                <div>Cantidad</div>
                <div>Total</div>
            </div>
            <div className="row18">
                {
                    params.MostrarMoneda && (<div className={`b-${_moneda}`}>{_moneda}</div>)
                }
                {
                    +params.PorVenta > 0 && (<div>{params.PorVenta}</div>)
                }
                {
                    +params.PorCompra > 0 && (<div>{params.PorCompra}</div>)
                }
                <div className={Item.Tipo}>{Item.Tipo}</div>
                <div>{numeral(Item.Precio).format("0,000.00")}</div>
                <div>{numeral(Item.Cantidad).format("0,000.00000000")}</div>
                <div>{numeral(Item.Total).format("0,000.00")}</div>
            </div>
        </div>
    </>)
}
